// Hero.js (example)
import React, { useState, useEffect } from 'react';
import { animated, useSpring } from 'react-spring'; // Animation library
import styled from 'styled-components';
import {Ts} from '../Config/switcher'

const Hero = ({lang}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const T = (value, key='home') => Ts(lang, key, value)

  useEffect(() => {
//    const trigger = useScrollTrigger({ onEnter: () => setIsScrolled(true), onLeave: () => setIsScrolled(false) });
//    return () => trigger.cleanup();
  }, []);

  const heroAnimation = useSpring({
    from: { opacity: 0 },
    to: { opacity: isScrolled ? 1 : 0 },
    config: { duration: 1000 },
  });

  return (
    <HeroContainer style={heroAnimation} id="about">
      <p className='brillant'>{T('about')}</p>
    </HeroContainer>
  );
};


const HeroContainer = styled.div`
max-width: 1024px;
margin: auto;
  background-image: url('landing.jpg');
  background-size: cover; /* contain; */
  background-position: center;
  height: 90vh;
  opacity: 0.9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-repeat: no-repeat;
  background-color: rgb(242,251,254);
  align-items: center;
  color: #fff;
`;

export default Hero;

